// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--22w0l";
export var container = "styles-module--container--2xEoA";
export var sitemap = "styles-module--sitemap--2wGvB";